/** @jsx _j **/
/** @jsxFrag _f **/

const { jsx: _j, F: _f } = require('astroturf');
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Layout from '@4c/layout';
import Logo from '@bfly/icons/Logo';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Anchor from './Anchor';
import Header from './Header';
import Link from './Link';
// FIXME: React.ComponentProps doesn't pick up specified defaultProps as
//  optional, so we need to explicitly mark them optional and set defaults
//  below to make type checking happy.
const defaultProps = {
  LogoComponent: Logo,
  staticLink: false,
  href: '/'
};

function NavbarBrand({
  LogoComponent = Logo,
  staticLink = false,
  href = '/',
  children,
  ...props
}) {
  const content = React.createElement(React.Fragment, null, _j(LogoComponent, {
    css: [require("./NavbarBrand-CssProp1_LogoComponent.module.scss"), []]
  }), React.createElement("span", {
    className: "sr-only"
  }, React.createElement(FormattedMessage, {
    id: "@bfly/ui:navbar.homeAlt",
    defaultMessage: "Home"
  })), children && React.createElement(Header.Title, {
    className: "d-none d-md-block ml-3"
  }, children));
  return staticLink ? React.createElement(Layout, _extends({
    as: Anchor,
    href: href,
    align: "center"
  }, props), content) : React.createElement(Layout, _extends({
    as: Link,
    to: href,
    align: "center"
  }, props), content);
}

NavbarBrand.defaultProps = defaultProps;
export default NavbarBrand;